import { IAugmentedJQuery } from 'angular';
import type { ITextScaleLimitController } from './text-scale.types';
import { textScaleCssClassHidden } from './text-scale.constants';
class TextScaleLimitController implements ITextScaleLimitController {
  public element!: HTMLElement;

  /* @ngInject */
  constructor(private readonly $element: IAugmentedJQuery) {}
  $onInit() {
    this.element = this.$element[0];
  }
  $postLink() {
    if (!this.element.querySelector('[data-text-scale]')) {
      this.element.classList.remove(textScaleCssClassHidden);
    }
  }
}
TextScaleLimitController.$inject = ["$element"];
export default TextScaleLimitController;